import { createStyles } from '@svg/antd/es/theme/utils';

// 标题相关样式
export const titleStyles = createStyles(({ token }) => ({
    directoryContainer: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        cursor: 'pointer',
        marginBottom: '8px',
        '&:hover': {
            backgroundColor: '#f0f0f0'
        }
    },
    categoryTitle: {
        position: 'relative',
        display: 'inline-block',
        fontSize: '14px',
        fontWeight: 700,
        lineHeight: '20px',
        color: token.colorText,
        '&::after': {
            content: '""',
            position: 'absolute',
            left: 0,
            bottom: 0,
            width: '100%',
            height: '8px',
            background: 'linear-gradient(270deg, rgba(20, 127, 250, 0.00) 0%, rgba(20, 127, 250, 0.30) 100%)'
        }
    },
    categoryTitleHover: {
        '&:hover': {
            color: token.colorTextSecondary
        },
    },
    categoryTitleActive: {
        color: token.colorPrimary,
    },
    triangleIcon: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: '24px',
        height: '24px',
        color: token.colorText,
    },
    arrowUp: {
        display: 'inline-block',
        width: 0,
        height: 0,
        borderLeft: '4px solid transparent',
        borderRight: '4px solid transparent',
        borderBottom: '5px solid #959598'
    },
    arrowDown: {
        display: 'inline-block',
        width: 0,
        height: 0,
        borderLeft: '4px solid transparent',
        borderRight: '4px solid transparent',
        borderTop: '5px solid #959598'
    }
})); 